//import { MainStorage } from "./MainStorage";

import { MainStorage } from "./MainStorage";

export class ApiConnect
{
    private ms:MainStorage=MainStorage.getInstance();
    
   
    private params:string[]=[];

    public Send(callNumber:number,callback:Function)
    {
       // const obj:any={"data":this.params.join("|")};
        const params2=this.params.join("|");
        //console.log(this.params);
       // const jsonObj:string=JSON.stringify(obj);
    //    let url:string="https://localhost/itemscribe/api/gateway.php?callNumber=";
       // let url:string="https://copylists.com/listadmin/api/gateway.php?callNumber=";
        //let url:string="https://itemscribe.com/api/gateway.php?callNumber=";
        
        fetch(this.ms.apiURL+"?callNumber="+callNumber+"&z="+params2,{
            method:"post"           
        }).then(
           response=>{
            if (response.ok) {
                response.json().then(json => {
                    console.log("callback");
                   // console.log(json);
                    callback(json);
                  });
            }
           })        
    }
    public Send2(callNumber:number,callback:Function)
    {
        const params2=this.params.join("|");
        let fd:FormData=new FormData();
        fd.append("z",params2);
        //console.log(this.params);
       // const jsonObj:string=JSON.stringify(obj);
        //let url:string="http://localhost/itemscribe/api/gateway.php?callNumber=";
        let url:string="https://itemscribe.com/subjectscribeapp/api/gateway.php?callNumber=";
        fetch(url+callNumber,{
            method:"post",
            body:fd          
        }).then(
           response=>{
            if (response.ok) {
                response.json().then(json => {
                    console.log("callback");
                    console.log(json);
                    callback(json);
                  });
            }
           })       
    }
    public clear()
    {
        this.params=[];
    }
    public addParam(data:string)
    {
        this.params.push(data);
    }
}
export default ApiConnect;
/**
 * 900 getbuildercats
901 getbuilderclosings
902 getbuilderopens
903 getbuildersents
904 getbuildersubcats
905 getrandbuildersent
906 addbuildercat
907 addbuildersent
908 addbuildersubcat
 */